import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F5F5F5",
      "fill-rule": "evenodd",
      d: "M8.58 5.693a.543.543 0 0 0-.824.465v15.184c0 .423.462.684.824.465l12.597-7.592a.543.543 0 0 0 0-.93zm-2.997.465c0-2.114 2.308-3.418 4.119-2.326l12.597 7.592c1.752 1.056 1.752 3.596 0 4.652L9.702 23.668c-1.81 1.092-4.119-.212-4.119-2.326z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }